import { useState } from "react";
import useHttp from "./use_http";
import { useFormik } from "formik";
import { PromotionsEnum } from "../utils/enums";
import toast from "react-hot-toast";
import {
  createCouponSchema,
  updateCouponLimitSchema,
  updateCouponSchema,
} from "../utils/schema";
import { useDispatch } from "react-redux";
import { setCreateCouponModal } from "../features/app/app_slice";
import moment from "moment";

const useCoupons = () => {
  const dispatch = useDispatch();
  const { httpService } = useHttp();

  const [loadings, setLoadings] = useState({
    getCoupons: false,
    createCoupon: false,
    updateCoupon: false,
  });
  const [getCoursesLoading, setGetCoursesLoading] = useState(false);

  const [updateModal, setUpdateModal] = useState(false);

  const [courses, setCourses] = useState([]);
  const [couponsData, setCouponsData] = useState([]);

  const getCourses = async () => {
    let paramsData = {
      page: 1,
      limit: 100,
    };
    try {
      setGetCoursesLoading(true);
      const response = await httpService.get("instructor/course/list", {
        params: paramsData,
      });
      setGetCoursesLoading(false);
      if (response.data.courses) {
        setCourses(response.data.courses);
      } else {
        setCourses([]);
      }
    } catch ({ err, response }) {
      setGetCoursesLoading(false);
    }
  };

  const getCoupons = async () => {
    try {
      setLoadings({ ...loadings, getCoupons: true });
      const response = await httpService.get("discount");
      setLoadings({ ...loadings, getCoupons: false });
      if (response.data) {
        setCouponsData(response.data);
      }
    } catch ({ err, response }) {
      setLoadings({ ...loadings, getCoupons: false });
    }
  };

  const createCouponController = useFormik({
    initialValues: {
      code: "",
      type: PromotionsEnum[0].value,
      amount: "",
      startDate: null,
      endDate: null,
      usageLimit: "",
      courseIds: [],
      isActive: true,
      description: "",
    },
    validationSchema: createCouponSchema,
    onSubmit: (values) => {
      createCoupon(values);
    },
  });

  const createCoupon = async (values) => {
    let postData = {
      type: 1,
      valueType: 2,
      code: values.code,
      amount: parseFloat(values.amount),
      isActive: values.isActive,
    };
    if (values.startDate) {
      postData["startDate"] = moment(values.startDate.$d).format("YYYY-MM-DD");
    }
    if (values.endDate) {
      postData["endDate"] = moment(values.endDate.$d).format("YYYY-MM-DD");
    }
    if (values.usageLimit?.length > 0) {
      postData["usageLimit"] = parseInt(values.usageLimit);
    }
    if (values.courseIds?.length > 0) {
      postData["courseIds"] = values.courseIds?.map((item) => {
        return item;
      });
    }
    if (values.description?.length > 0) {
      postData["description"] = values.description;
    }
    try {
      setLoadings({ ...loadings, createCoupon: true });
      const response = await httpService.post("discount", postData);
      setLoadings({ ...loadings, createCoupon: false });
      if (response.status < 400) {
        toast.success(response.data.message);
        dispatch(setCreateCouponModal(false));
        getCoupons();
      }
    } catch ({ err, response }) {
      setLoadings({ ...loadings, createCoupon: false });
    }
  };

  const updateCouponController = useFormik({
    initialValues: {
      coupon_id: null,
      code: "",
      startDate: null,
      endDate: null,
      usageLimit: "",
      courseIds: [],
      isActive: true,
      description: "",
    },
    validationSchema: updateCouponSchema,
    onSubmit: (values) => {
      updateCoupon(values);
    },
  });

  const updateCoupon = async (values) => {
    let postData = {
      startDate: values.startDate
        ? moment(values.startDate.$d).format("YYYY-MM-DD")
        : null,
      endDate: values.endDate
        ? moment(values.endDate.$d).format("YYYY-MM-DD")
        : null,
      usageLimit: values.usageLimit?.length > 0 ? values.usageLimit : null,
      courseIds:
        values.courseIds?.length > 0
          ? values.courseIds.map((item) => {
              return item;
            })
          : null,
      isActive: values.isActive,
      description: values.description?.length > 0 ? values.description : null,
    };
    try {
      setLoadings({ ...loadings, updateCoupon: true });
      const response = await httpService.put(
        `discount/${values.coupon_id}`,
        postData,
      );
      setLoadings({ ...loadings, updateCoupon: false });
      if (response.status < 400) {
        toast.success(response.data.message);
        setUpdateModal(false);
        getCoupons();
      }
    } catch ({ err, response }) {
      setLoadings({ ...loadings, updateCoupon: false });
    }
  };

  const exports = {
    // entity methods
    getCourses,
    getCoupons,
    // controller methods
    createCouponController,
    updateCouponController,
    // entity states
    courses,
    couponsData,
    // controller states
    updateModal,
    setUpdateModal,
    // loading states
    loadings,
    getCoursesLoading,
  };
  return exports;
};
export default useCoupons;
